// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"870bb73e","239":"d8d7502d","455":"9dfdab53","977":"2ff32738"}[chunkId] + ".chunk.js";
};